import 'jspdf-autotable'
import { jsPDF } from "jspdf"
import Loading from '@/components/widgets/Loading.vue'

export default {
  data() {
    return {
      loading: false,
      buyer: {
        name: 'SANGTHAI INDUSTRY CO., LTD.',
        address: '94/43 หมู่ 4 เศรษฐกิจ 1-บางปลา ต.บ้านเกาะ อ.เมือง จ.สมุทรสาคร',
        taxno: '12345678910',
        tel: '0-3483-0032-7, 0-3483-0289',
        fax: '0-3483-0028'
      },
      document: {
        so: 'WHDO5311-0001',
        dn: 'WHDO5311-0002',
        no: 'PO-202216554654',
        date: '25/09/2019',
        condition: 'ชำระภายใน 7 วัน',
        credit: '30 วัน',
        duedate: '25/09/2022'
      },
      customer: {
        code: '001',
        name: 'เกริกวิทย์ ทำของดี',
        address: 'เลขที่ 72 ถ.แจ้งวัฒนะ ต.ตลาดบางเขน อ.หลักสี่ รหัสไปรษณีย์ 10210',
        taxno: '12345678999',
        tel: '0-3483-0032-7'
      },
      products: [
        {
          _id: '61837be876a431b5936932ba',
          code: 'P-001',
          name: 'สินค้า1',
          qty: 250,
          unit: 'แท่ง',
          storage: '01',
          treasury: '001'
        },
        {
          _id: '61837be876a431b5936932bb',
          code: 'P-002',
          name: 'สินค้า2',
          qty: 250,
          unit: 'แท่ง',
          storage: '01',
          treasury: '001'
        },
        {
          _id: '61837be876a431b5936932bb',
          code: 'P-003',
          name: 'สินค้า3',
          qty: 250,
          unit: 'แท่ง',
          storage: '01',
          treasury: '001'
        },
        {
          _id: '61837be876a431b5936932bb',
          code: 'P-004',
          name: 'สินค้า4',
          qty: 250,
          unit: 'แท่ง',
          storage: '01',
          treasury: '001'
        }
      ],
      note: 'กรุณาโอนเงินเข้าบัญชี ธนาคารไทยพาณิชย์ ชื่อบัญชี สมกานดา ศุภชลาลัย เลขที่บัญชี xxxxxxxxxx สาขา พีทีที คริสตัล',
      discount: 150,
      nettotal: 0,
      afterDisc: 0
    }
  },
  components: {
    Loading
  }, 
  mounted() {
    this.$nextTick(() => {
      this.onInitData()
    })
  },
  methods: {
    onInitData() {
      for (let index = 0; index < this.products.length; index++) {
        const element = this.products[index]
        this.nettotal += element.qty
      }
    },
    async onInitIFrame() {
      this.loading = true
      setTimeout(async () => {
        const doc = new jsPDF('p','mm','a4')
        await this.onInitDocument(doc)
        let element = document.getElementById('refunds')
        if (element) {
          element.setAttribute("src", doc.output('bloburl'))
          setTimeout(() => {
            this.loading = false
            this.onIframePrint()
          }, 1500)
        }
      }, 1000)
    },
    onInitDocument(doc) {
      return new Promise(async(resolve, reject) => {
        try {
          doc.addFileToVFS(
            'THSarabunNew.ttf',
            // ttf font file converted to base64
            // following is Consolas with only hex digit glyphs defined (0-9, A-F)
            this.thSarabunNormal
          )
          // add custom font to file
          doc.addFont('THSarabunNew.ttf', 'THSarabunNew', 'normal')
          doc.setFont('THSarabunNew', 'normal')

          doc.addFileToVFS(
            'THSarabunNew Bold.ttf',
            // ttf font file converted to base64
            // following is Consolas with only hex digit glyphs defined (0-9, A-F)
            this.thSarabunBold
          )
          // add custom font to file
          doc.addFont('THSarabunNew Bold.ttf', 'THSarabunNew', 'bold')
          doc.setFont('THSarabunNew', 'bold')

          const head = await this.onInitHeader()
          const body = await this.onInitBody(doc)
          doc.autoTable({
            theme: 'plain',
            margin: { top: 8, bottom: 0, left: 8, right: 8 },
            styles: {
              font: 'THSarabunNew'
            },
            headStyles: {
              valign: 'top',
              minCellHeight: 0
            },
            bodyStyles: {
              valign: 'top',
              minCellHeight: 0
            },
            footStyles: {
              valign: 'top',
              halign: 'center',
              minCellHeight: 0
            },
            showFoot: 'lastPage',
            head: head,
            body: body,
            willDrawCell (data) {
              if (data.cell.raw && data.section === 'head') {
                if (data.cell.raw.content === 'breaklineheader') {
                  const width = doc.internal.pageSize.getWidth() - 16
                  data.doc.setLineWidth(0.2)
                  data.doc.setDrawColor(100, 116, 139)
                  data.doc.line(data.cell.x, data.cell.y + 5, data.cell.x + width, data.cell.y + 5)
                }
              }
            }
          })
          const sub_footer = await this.onInitSubFooter(doc)
          doc.autoTable({
            theme: 'plain',
            margin: { top: 8, bottom: 8, left: 8, right: 8 },
            startY: doc.lastAutoTable.finalY,
            styles: {
              font: 'THSarabunNew'
            },
            headStyles: {
              valign: 'top',
              minCellHeight: 0
            },
            bodyStyles: {
              valign: 'top',
              minCellHeight: 0
            },
            footStyles: {
              valign: 'top',
              halign: 'center',
              minCellHeight: 0
            },
            showFoot: 'lastPage',
            foot: sub_footer
          })

          const footer = await this.onInitFooter(doc)
          doc.autoTable({
            theme: 'plain',
            margin: { top: 8, bottom: 8, left: 8, right: 8 },
            styles: {
              font: 'THSarabunNew'
            },
            headStyles: { },
            bodyStyles: {
              valign: 'top',
              minCellHeight: 0
            },
            footStyles: {
              valign: 'bottom',
              halign: 'center',
              minCellHeight: 0
            },
            showFoot: 'lastPage',
            foot: footer,
            willDrawCell (data) {
              if (data.cell.raw && data.section === 'foot') {
                if (data.cell.raw.content === 'storage') {
                    data.doc.setLineWidth(0.25)
                    data.doc.setDrawColor(15, 23, 42)
                    data.doc.line(data.cell.x + 4, data.cell.y + 18, data.cell.x + 45, data.cell.y + 18)
                  }
                if (data.cell.raw.content === 'issuer') {
                  data.doc.setLineWidth(0.25)
                  data.doc.setDrawColor(15, 23, 42)
                  data.doc.line(data.cell.x + 4, data.cell.y + 18, data.cell.x + 45, data.cell.y + 18)
                }
                if (data.cell.raw.content === 'approved') {
                  data.doc.setLineWidth(0.25)
                  data.doc.setDrawColor(15, 23, 42)
                  data.doc.line(data.cell.x + 4, data.cell.y + 18, data.cell.x + 45, data.cell.y + 18)
                }
                if (data.cell.raw.content === 'accepted' ) {
                  data.doc.setLineWidth(0.25)
                  data.doc.setDrawColor(15, 23, 42)
                  data.doc.line(data.cell.x + 4, data.cell.y + 18, data.cell.x + 45, data.cell.y + 18)
                }
              }
            }
          })
          resolve(doc)
        } catch (error) {
          reject(error)
        }
      })
    },
    onInitHeader() {
      return new Promise(async (resolve, reject) => {
        const head = [
          [
            {
              content: 'ใบคืนสินค้า',
              colSpan: 9,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 26,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'bold',
                halign: 'left',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: 'Refunds',
              colSpan: 9,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 22,
                textColor: [15, 23, 42],
                cellPadding: {
                  bottom: 2
                },
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: this.buyer.name,
              colSpan: 5,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            },
            {
              content: 'เลขที่:',
              colSpan: 3,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            },
            {
              content: this.document.so,
              colSpan: 1,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: this.buyer.address,
              colSpan: 6,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            },
            {
              content: 'วันที่:',
              colSpan: 2,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            },
            {
              content: this.document.date,
              colSpan: 1,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: `เลขประจำตัวผู้เสียภาษี: ${this.buyer.taxno}`,
              colSpan: 5,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            },
            {
              content: 'เลขที่ใบ D/N:',
              colSpan: 3,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            },
            {
              content: this.document.dn,
              colSpan: 1,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: `ติดต่อ: ${this.buyer.tel}`,
              colSpan: 5,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            },
            {
              content: 'วันที่ใบ D/N: ',
              colSpan: 3,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            },
            {
              content: this.document.date,
              colSpan: 1,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: `Fax: ${this.buyer.fax}`,
              colSpan: 9,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: 'breaklineheader',
              colSpan: 9,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [255, 255, 255],
                cellPadding: 0,
                fontStyle: 'bold',
                halign: 'center',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: `รหัสลูกค้า ${this.customer.code}`,
              colSpan: 9,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: {
                  top: 2
                },
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: `ลูกค้า ${this.customer.name}`,
              colSpan: 5,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            },
            {
              content: `เลขประจำตัวผู้เสียภาษี: ${this.customer.taxno}`,
              colSpan: 4,
              styles: {
                lineWidth: 0,
                overflow: 'visible',
                cellWidth: 'wrap',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: this.customer.address,
              colSpan: 6,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: {
                  bottom: 5
                },
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            },
            {
              content: `ติดต่อ: ${this.customer.tel}`,
              colSpan: 3,
              styles: {
                lineWidth: 0,
                overflow: 'visible',
                cellWidth: 'wrap',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: {
                  bottom: 5
                },
                fontStyle: 'normal',
                halign: 'right',
                valign: 'top'
              }
            }
          ],
          [
            {
              content: 'ลำดับ',
              styles: {
                  lineWidth: 0.1,
                  fillColor: [243, 244, 246],
                  cellPadding: 2,
                  cellWidth: 'auto',
                  fontSize: 15,
                  textColor: [15, 23, 42],
                  fontStyle: 'normal',
                  halign: 'center',
                  valign: 'top'
              }
            },
            {
              content: 'รหัสสินค้า',
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'left',
                valign: 'top'
              }
            },
            {
              content: 'รายการ',
              colSpan: 3,
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'center',
                valign: 'top'
              }
            },
            {
              content: 'หน่วย',
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'right',
                valign: 'top'
              }
            },
            {
              content: 'ที่เก็บ',
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'right',
                valign: 'top'
              }
            },
            {
              content: 'คลัง',
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'right',
                valign: 'top'
              }
            },
            {
              content: 'จำนวน',
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'right',
                valign: 'top'
              }
            }
          ]
        ]
        resolve(head)
      })
    },
    onInitBody(doc) {
      return new Promise(async (resolve, reject) => {
        const width = doc.internal.pageSize.getWidth() - 18
        const portion = width / 9
        const fraction = portion / 2
        const halfTwo = portion + fraction
        const data = this.products          
        const body = []
        for (let index = 0; index < data.length; index++) {
        const element = data[index]
        let obj = {}
        obj = [
          {
            content: index + 1,
            styles: {
              cellWidth: (portion / 1.5),
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              fontSize: 15,
              fillColor: [255, 255, 255],
              textColor: [15, 23, 42],
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              fontStyle: 'normal',
              halign: 'center',
              valign: 'middle'
            }
          },
          {
            content: element.code,
            styles: {
              cellWidth: portion,
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              fontSize: 15,
              fillColor: [255, 255, 255],
              textColor: [15, 23, 42],
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              fontStyle: 'normal',
              halign: 'left',
              valign: 'middle'
            }
          },
          {
            content: element.name,
            colSpan: 3,
            styles: {
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              cellWidth: 'auto',
              fontSize: 15,
              fillColor: [255, 255, 255],
              textColor: [15, 23, 42],
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              fontStyle: 'normal',
              halign: 'left',
              valign: 'middle'
            }
          },
          {
            content: element.unit,
            styles: {
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              cellWidth: portion,
              fontSize: 15,
              fillColor: [255, 255, 255],
              textColor: [15, 23, 42],
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              fontStyle: 'normal',
              halign: 'right',
              valign: 'middle'
            }
          },
          {
            content: element.storage,
            styles: {
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              fontSize: 15,
              cellWidth: portion,
              fillColor: [255, 255, 255],
              textColor: [15, 23, 42],
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              fontStyle: 'normal',
              halign: 'right',
              valign: 'middle'
            }
          },
          {
            content: element.treasury,
            styles: {
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              fontSize: 15,
              cellWidth: portion,
              fillColor: [255, 255, 255],
              textColor: [15, 23, 42],
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              fontStyle: 'normal',
              halign: 'right',
              valign: 'middle'
            }
          },
          {
            content: this.$options.filters.numberFormat(element.qty),
            styles: {
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              fontSize: 15,
              cellWidth: halfTwo,
              fillColor: [255, 255, 255],
              textColor: [15, 23, 42],
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              fontStyle: 'normal',
              halign: 'right',
              valign: 'middle'
            }
          }
        ]
        body.push(obj)
      }
      let emptyBody = {}
      emptyBody = [
        {
          content: '',
          styles: {
            cellWidth: portion / 1.4,
            lineWidth: {
              left: 0.1,
              right: 0.1
            },
            fontSize: 15,
            fillColor: [255, 255, 255],
            textColor: [255, 255, 255],
            cellPadding: {
              left: 2,
              right: 2,
              top: 1,
              bottom: 1
            },
            fontStyle: 'normal',
            halign: 'center',
            valign: 'middle'
          }
        },
        {
          content: '',
          styles: {
            cellWidth: portion + (fraction / 2),
            lineWidth: {
              left: 0.1,
              right: 0.1
            },
            fontSize: 15,
            fillColor: [255, 255, 255],
            textColor: [255, 255, 255],
            cellPadding: {
              left: 2,
              right: 2,
              top: 1,
              bottom: 1
            },
            fontStyle: 'normal',
            halign: 'center',
            valign: 'middle'
          }
        },
        {
          content: '',
          colSpan: 3,
          styles: {
            lineWidth: {
              left: 0.1,
              right: 0.1
            },
            cellPadding: {
              left: 2,
              right: 2,
              top: 1,
              bottom: 1
            },
            cellWidth: 'auto',
            fontSize: 15,
            fillColor: [255, 255, 255],
            textColor: [255, 255, 255],
            fontStyle: 'normal',
            halign: 'left',
            valign: 'middle'
          }
        },
        {
          content: '',
          styles: {
            lineWidth: {
              left: 0.1,
              right: 0.1
            },
            cellPadding: {
              left: 2,
              right: 2,
              top: 1,
              bottom: 1
            },
            cellWidth: portion,
            fontSize: 15,
            fillColor: [255, 255, 255],
            textColor: [255, 255, 255],
            fontStyle: 'normal',
            halign: 'right',
            valign: 'top'
          }
        },
        {
          content: '',
          styles: {
            lineWidth: {
              left: 0.1,
              right: 0.1
            },
            cellPadding: {
              left: 2,
              right: 2,
              top: 1,
              bottom: 1
            },
            cellWidth: portion + 5,
            fontSize: 15,
            fillColor: [255, 255, 255],
            textColor: [255, 255, 255],
            fontStyle: 'normal',
            halign: 'right',
            valign: 'top'
          }
        },
        {
          content: '',
          styles: {
            lineWidth: {
              left: 0.1,
              right: 0.1
            },
            cellPadding: {
              left: 2,
              right: 2,
              top: 1,
              bottom: 1
            },
            cellWidth: portion,
            fontSize: 1,
            fillColor: [255, 255, 255],
            textColor: [255, 255, 255],
            fontStyle: 'normal',
            halign: 'center',
            valign: 'top'
          }
        },
        {
          content: '',
          styles: {
            lineWidth: {
              left: 0.1,
              right: 0.1
            },
            cellPadding: {
              left: 2,
              right: 2,
              top: 1,
              bottom: 1
            },
            cellWidth: portion,
            fontSize: 1,
            fillColor: [255, 255, 255],
            textColor: [255, 255, 255],
            fontStyle: 'normal',
            halign: 'center',
            valign: 'top'
          }
        }
      ]

      if (body.length <= 10) {
        const number = 10 - body.length
        for (let index = 0; index < number; index++) {
          body.push(emptyBody)
        }
      }
      resolve(body)
      })
    },
    onInitFooter(doc) {
      return new Promise((resolve, reject) => {
        const width = doc.internal.pageSize.getWidth() - 20
        const content_width = parseInt(width/4)

        const footer = []
        const signer_line = [
          {
            content: `storage`,
            colSpan: 2,
            styles: {
            cellWidth: 'auto',
            fontSize: 15,
            textColor: [255, 255, 255],
            cellPadding: {
                top: 15
            },
            fontStyle: 'normal',
            halign: 'center',
            valign: 'bottom'
            }
          },
          {
            content: `issuer`,
            colSpan: 2,
            styles: {
            cellWidth: 'auto',
            fontSize: 15,
            textColor: [255, 255, 255],
            cellPadding: 0,
            fontStyle: 'normal',
            halign: 'center',
            valign: 'bottom'
            }
          },
          {
            content: `approved`,
            colSpan: 2,
            styles: {
            cellWidth: 'auto',
            fontSize: 15,
            textColor: [255, 255, 255],
            cellPadding: 0,
            fontStyle: 'normal',
            halign: 'center',
            valign: 'bottom'
            }
          },
          {
            content: `accepted`,
            colSpan: 2,
            styles: {
            cellWidth: 'auto',
            fontSize: 15,
            textColor: [255, 255, 255],
            cellPadding: 0,
            fontStyle: 'normal',
            halign: 'center',
            valign: 'bottom'
            }
          }
        ]
        footer.push(signer_line)

        const signer_style = {
          cellWidth: content_width,
          fontSize: 15,
          textColor: [15, 23, 42],
          cellPadding: 0,
          fontStyle: 'normal',
          halign: 'center',
          valign: 'bottom'
        }
        const signer_name = [
          {
            content: 'พนักงานคลังสินค้า',
            colSpan: 2,
            styles: signer_style
          },
          {
            content: 'ผู้ตรวจสอบ',
            colSpan: 2,
            styles: signer_style
          },
          {
            content: 'ผู้อนุมัติ',
            colSpan: 2,
            styles: signer_style
          },
          {
            content: 'ผู้ส่งของ',
            colSpan: 2,
            styles: {
              cellWidth: 'auto',
              fontSize: 15,
              textColor: [15, 23, 42],
              cellPadding: 0,
              fontStyle: 'normal',
              halign: 'center',
              valign: 'bottom'
            }
          }
        ]
        footer.push(signer_name)
        
        const signer_date = [
          {
            content: `( ${ this.$options.filters.getDateShortFormatted(new Date())} )`,
            colSpan: 2,
            styles: signer_style
          },
          {
            content: `( ${ this.$options.filters.getDateShortFormatted(new Date())} )`,
            colSpan: 2,
            styles: signer_style
          },
          {
            content: `( ${ this.$options.filters.getDateShortFormatted(new Date())} )`,
            colSpan: 2,
            styles: signer_style
          },
          {
            content: `( ${ this.$options.filters.getDateShortFormatted(new Date())} )`,
            colSpan: 2,
            styles: {
              cellWidth: 'auto',
              fontSize: 15,
              textColor: [15, 23, 42],
              cellPadding: 0,
              fontStyle: 'normal',
              halign: 'center',
              valign: 'bottom'
            }
          }
        ]
        footer.push(signer_date)
        resolve(footer)
    })
    },
    onInitSubFooter(doc) {
      return new Promise((resolve, reject) => {
        const width = doc.internal.pageSize.getWidth() - 18
        const portion = width / 9
        const fraction = portion / 2
        const halfTwo = portion + fraction
        
        const footer = []
        const total = [{
            content: this.note,
            colSpan: 9,
            styles: {
            lineWidth: 0.1,
            cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
            },
            cellWidth: 'auto',
            fontSize: 15,
            textColor: [15, 23, 42],
            fontStyle: 'normal',
            halign: 'left',
            valign: 'top'
            }
        },
        {
            content: 'ยอดรวม',
            colSpan: 2,
            styles: {
            lineWidth: 0.1,
            fillColor: [243, 244, 246],
            cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
            },
            cellWidth: portion,
            fontSize: 15,
            textColor: [15, 23, 42],
            fontStyle: 'normal',
            halign: 'right',
            valign: 'top'
            }
        },
        {
            content: this.$options.filters.numberFormat(this.nettotal),
            colSpan: 2,
            styles: {
            lineWidth: 0.1,
            fillColor: [255, 255, 255],
            cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
            },
            cellWidth: halfTwo,
            fontSize: 15,
            textColor: [15, 23, 42],
            fontStyle: 'normal',
            halign: 'right',
            valign: 'top'
            }
        }
        ]
        footer.push(total)
        resolve(footer)
      })
    },
    onIframePrint() {
      let iFrame = document.getElementById("refunds")
      iFrame.focus()
      iFrame.contentWindow.print()
    }
  }
}
